import { Injectable } from '@angular/core';

export interface IntercomUser {
  user_id: string;
  name: string;
  email: string;
  plan?: string | null;
}

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Intercom: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  private readonly APP_ID = 'w790x6hc';
  private isBooted = false;

  boot(user: IntercomUser): void {
    if (typeof window.Intercom !== 'function') {
      console.error(
        'Intercom script is not available. This might be due to an ad blocker or network issue. Please check your browser extensions and network connection.'
      );
      return;
    }

    const settings = {
      app_id: this.APP_ID,
      user_id: user.user_id,
      name: user.name,
      email: user.email,
      plan: user.plan,
      hide_default_launcher: true,
    };

    window.Intercom('boot', settings);
    this.isBooted = true;
  }

  update(data: { plan: string }): void {
    if (!this.isBooted) {
      console.warn('Intercom cannot be updated before it is booted.');
      return;
    }
    window.Intercom('update', data);
  }

  openChat(): void {
    if (!this.isBooted) {
      console.warn('Intercom not booted, cannot open chat.');
      return;
    }
    window.Intercom('show');
  }

  shutdown(): void {
    if (this.isBooted) {
      window.Intercom('shutdown');
      this.isBooted = false;
    }
  }
} 

